import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export const useMutationMemberInvoicePdfAsMember = ({
  api,
}: {
  api: ApiType;
}) =>
  useMutation({
    mutationFn: async ({ invoiceNumber }: { invoiceNumber: string }) =>
      await api.profileApi.invoicePdf(invoiceNumber),
  });
